export default __webpack_public_path__ + "static/media/DISTRIBUCION_ITEM_ICON_4.c88f94d1.svg";